import React from 'react';

const RELOAD_STORAGE_KEY = 'chunk-reload-timestamp';
const RELOAD_COOLDOWN_MS = 10000;

/**
 * Wraps React.lazy with automatic retry + page reload on chunk load failures.
 * After a new deployment, stale chunk hashes in the cached index.html will
 * cause dynamic imports to fail. This detects the error and forces a single
 * hard reload to fetch the new index.html, preventing blank-page scenarios.
 */
const lazyWithRetry = (importFn) =>
  React.lazy(() =>
    importFn().catch((error) => {
      const isChunkError =
        error?.message?.includes('dynamically imported module') ||
        error?.message?.includes('Failed to fetch') ||
        error?.message?.includes('Loading chunk') ||
        error?.name === 'ChunkLoadError';

      if (!isChunkError) {
        throw error;
      }

      const lastReload = Number(sessionStorage.getItem(RELOAD_STORAGE_KEY) || 0);
      const now = Date.now();

      if (now - lastReload > RELOAD_COOLDOWN_MS) {
        sessionStorage.setItem(RELOAD_STORAGE_KEY, String(now));
        window.location.reload();
      }

      throw error;
    }),
  );

export default lazyWithRetry;
